import OrderHistoryContainer from "../../../../Components/Applications/Ecommerce/OrderHistory/OrderHistoryContainer";

const OrderHistory = () => {
  return <OrderHistoryContainer />;
};

export default OrderHistory;
